"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.string.pad-start");
var _rate_limit_config = require("@/api/cfg/rate_limit_config");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'RateLimitConfig',
  data: function data() {
    return {
      loading: false,
      submitLoading: false,
      list: [],
      total: 0,
      queryParams: {
        page: 1,
        limit: 10,
        configType: null,
        configName: null
      },
      dialogVisible: false,
      isEdit: false,
      form: {
        id: null,
        configName: '',
        configType: 'URL',
        urlPattern: '',
        ipMaxRequests: 0,
        userMaxRequests: 0,
        totalMaxRequests: 0,
        windowSeconds: 60,
        enabled: 1,
        priority: 0
      }
    };
  },
  computed: {
    dialogTitle: function dialogTitle() {
      return this.isEdit ? '编辑限流配置' : '新增限流配置';
    },
    rules: function rules() {
      var r = {
        configName: [{
          required: true,
          message: '请输入配置名称',
          trigger: 'blur'
        }],
        configType: [{
          required: true,
          message: '请选择配置类型',
          trigger: 'change'
        }],
        windowSeconds: [{
          required: true,
          message: '请输入时间窗口',
          trigger: 'blur'
        }]
      };
      if (this.form.configType === 'URL') {
        r.urlPattern = [{
          required: true,
          message: '请输入URL匹配前缀',
          trigger: 'blur'
        }];
      }
      return r;
    }
  },
  created: function created() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      this.loading = true;
      (0, _rate_limit_config.getConfigPage)(this.queryParams).then(function (response) {
        _this.list = response.data.list || [];
        _this.total = response.data.total || 0;
        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    },
    handleQuery: function handleQuery() {
      this.queryParams.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(size) {
      this.queryParams.limit = size;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(current) {
      this.queryParams.page = current;
      this.getList();
    },
    handleRefreshCache: function handleRefreshCache() {
      var _this2 = this;
      (0, _rate_limit_config.refreshCache)().then(function () {
        _this2.$message.success('缓存刷新成功');
      });
    },
    handleAdd: function handleAdd() {
      var _this3 = this;
      this.isEdit = false;
      this.form = {
        id: null,
        configName: '',
        configType: 'URL',
        urlPattern: '',
        ipMaxRequests: 0,
        userMaxRequests: 0,
        totalMaxRequests: 0,
        windowSeconds: 60,
        enabled: 1,
        priority: 0
      };
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this3.$refs.form && _this3.$refs.form.clearValidate();
      });
    },
    handleEdit: function handleEdit(row) {
      var _this4 = this;
      this.isEdit = true;
      this.form = {
        id: row.id,
        configName: row.configName,
        configType: row.configType,
        urlPattern: row.urlPattern || '',
        ipMaxRequests: row.ipMaxRequests,
        userMaxRequests: row.userMaxRequests,
        totalMaxRequests: row.totalMaxRequests || 0,
        windowSeconds: row.windowSeconds,
        enabled: row.enabled,
        priority: row.priority || 0
      };
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this4.$refs.form && _this4.$refs.form.clearValidate();
      });
    },
    submitForm: function submitForm() {
      var _this5 = this;
      this.$refs.form.validate(function (valid) {
        if (!valid) return;
        if (_this5.form.configType === 'URL' && !_this5.form.urlPattern) {
          _this5.$message.error('URL规则必须填写URL匹配前缀');
          return;
        }
        _this5.submitLoading = true;
        var apiFn = _this5.isEdit ? _rate_limit_config.updateConfig : _rate_limit_config.saveConfig;
        apiFn(_this5.form).then(function () {
          _this5.$message.success(_this5.isEdit ? '修改成功' : '新增成功');
          _this5.dialogVisible = false;
          _this5.submitLoading = false;
          _this5.getList();
        }).catch(function () {
          _this5.submitLoading = false;
        });
      });
    },
    formatDateTime: function formatDateTime(row, column, cellValue) {
      if (!cellValue) return '';
      var d = new Date(cellValue);
      var y = d.getFullYear();
      var m = String(d.getMonth() + 1).padStart(2, '0');
      var day = String(d.getDate()).padStart(2, '0');
      var h = String(d.getHours()).padStart(2, '0');
      var min = String(d.getMinutes()).padStart(2, '0');
      var s = String(d.getSeconds()).padStart(2, '0');
      return y + '-' + m + '-' + day + ' ' + h + ':' + min + ':' + s;
    },
    handleDelete: function handleDelete(row) {
      var _this6 = this;
      this.$confirm('确认删除配置 "' + row.configName + '" ?', '删除确认', {
        confirmButtonText: '确认删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _rate_limit_config.deleteConfig)(row.id).then(function () {
          _this6.$message.success('删除成功');
          _this6.getList();
        });
      }).catch(function () {});
    }
  }
};